// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_Base_URL: 'https://localhost:44372/api/'
  /*ApiSwagger: 'http://52.140.40.53:8086/api/',
  API_Base_URL: 'http://cfmsapi.esdinfra.com',
 rootUrl :'http://cfmsapi.esdinfra.com',*/
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
